import { GalleryType } from '../models';
import type { ActivityDetailsData, ActivityDetailsHeaderData } from '../models';

export function getActivityDetailsHeaderData(
  activityDetails: ActivityDetailsData | undefined
): ActivityDetailsHeaderData | undefined {
  if (!activityDetails) {
    return;
  }

  return {
    headerText: activityDetails.staticInfo.name,
    starsAmount: activityDetails.staticInfo.semboSunRating,
    subHeaderText: activityDetails.destination,
  };
}

export function getGalleryType(isSmallDevice: boolean): GalleryType {
  return isSmallDevice ? GalleryType.Swiper : GalleryType.Masonry;
}
